function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20 6l16 28H4z",
  stroke: "#000",
  strokeWidth: "2",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: "2",
  d: "M20 14v10"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "29",
  r: "2"
})));